import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import AlertMessage from "../../Components/UI/AlertMessage";
import { useLoginQuery } from "../../AppQuries/auth/use-login";
import PropTypes from "prop-types";
import Input from "../../Components/UI/Input";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { loggedInUser, login } from "../../core/redux/slice/authSlice";
import axios from "axios";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import {
  useLoginMutation,
  useUpdateLoginHistoryMutation,
} from "AppQuries/login/login";
import { useInsertAcademicMutation } from "AppQuries/master/Academic/acadamics";
import { useAcademicsQuery } from "AppQuries/master/Academic/get-all-academics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { setPermissions } from "core/redux/slice/userPermissionSlice";
import { requestPermission } from "notification";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
// import { adminAccess } from "core/json/access";
const LoginComponent = ({ onClick }) => {
  const userData = useSelector(loggedInUser);

  const navigate = useNavigate();

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessgae] = useState(null);
  const [isLoggedInSuccess, setIsLoggedInSuccess] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  // const [isLoading, setIsLoading] = useState(false);
  // const { refetch, data, isLoading, isError, error } = useLoginQuery(formData, {
  //   enabled: false,
  // });
  // if (isError) {
  //   setErrorMessgae(error.message || "Something went wrong");
  // }
  const { mutate: loginMutation, isLoading } = useLoginMutation();
  const { mutate: academic } = useInsertAcademicMutation();
  const { mutate: updateLogin } = useUpdateLoginHistoryMutation();
  // const { data: academicData, refetch } = useAcademicsQuery();
  const onSubmit = async (input) => {
    console.log(input);

    const updatedFormData = {
      email: input.email,
      password: input.password,
    };

    // const data = await axios.post(
    //   `${Api_EndPoints.PayrollURL}${Api_EndPoints.Login}`,
    //   updatedFormData,
    //   {headers: { Authorization: "Basic d2luYXBwOmFkbWlu" },}

    // );

    loginMutation(updatedFormData, {
      onSuccess: async (data) => {
        if (data?.isSuccessful && Boolean(data?.isSuccessful)) {
          setErrorMessgae(false);
          setIsLoggedInSuccess(true);
          if (!data) {
            console.error("Login error: No data received");
            setErrorMessgae("Something went wrong");
            setIsLoggedInSuccess(false);
            return;
          }
          const { userRolesAcess, user, ...companyDetails } = data;
          // console.log("userRolesAcess", userRolesAcess);
          // const permissions = userRolesAcess?.flatMap((menu) =>
          //   menu.subMenu.map((subMenu) => ({
          //     userGroupCode: menu.userGroupCode || "",
          //     user: userData?.userName || "",
          //     formCode: menu.formCode || "", // Use parent menu formCode
          //     subMenu: subMenu.subMenu || "",
          //     menuName: menu.menuName || "",
          //     companyCode: menu.companyCode,
          //     isActive: true,
          //     haveView: subMenu.haveView ?? false,
          //     haveAdd: subMenu.haveAdd ?? false,
          //     haveEdit: subMenu.haveEdit ?? false,
          //     haveDelete: subMenu.haveDelete ?? false,
          //   }))
          // );

          dispatch(
            setPermissions({
              permissions: userRolesAcess || [],
            }),
          );

          const fcmToken = await requestPermission();

          const userDetails = {
            ...user,
            ...companyDetails,
            permissions: userRolesAcess || [],
            companyDetails: companyDetails,
            selectedLocationCode: user?.locationCode || "",
            selectedCompanyCode: companyDetails?.companyCode || 0,
            isAllCompanies: false,
            deviceId: fcmToken || "",
          };

          console.log("fcmToken", fcmToken);

          const updateData = {
            userID: user?.userID || 0,
            companyCode: companyDetails?.companyCode || 0,
            deviceId: fcmToken || "",
            lastLoginLocation: "",
            createUser: user?.userName,
            createDate: getCurrentFormattedDate(),
            modifyUser: user?.userName,
            modifyDate: getCurrentFormattedDate(),
            status: true,
          };

          if (fcmToken !== "") {
            updateLogin(updateData);
          }

          dispatch(
            login({ userData: userDetails, rememberMe: input.rememberMe }),
          );

          // dispatch(
          //   login({ userData: userDetails, rememberMe: input.rememberMe }),
          // );

          // setTimeout(() => {

          //   navigate("/");
          // }, 1000);
        } else {
          console.error("Login error:", data?.errorMessage);
          setErrorMessgae(data?.errorMessage || "Something went wrong");
          setIsLoggedInSuccess(false);
        }
      },
      onError: (error) => {
        console.error("Login error:", error);
        setIsLoggedInSuccess(false);
        setErrorMessgae(
          error?.response?.data?.message || "Something went wrong",
        );
      },
    });
  };

  const route = all_routes;

  useEffect(() => {
    if (userData?.isSuccessful && userData?.expireTime > Date.now()) {
      navigate(all_routes.dashboard);
    }
  }, [navigate, userData, all_routes]);

  useEffect(() => {
    dispatch(
      setPermissions({
        permissions: [],
      }),
    );
  }, []);
  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <button
              type="button"
              className="back-btn"
              onClick={onClick}
              aria-label="Back"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <div className="login-content user-login">
              <img
                src="assets/img/logo.jpeg"
                alt="Logo"
                className="logo mb-3"
              />
              <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
                <div className="">
                  <div className="login-userheading">
                    <h3>Sign In</h3>
                    <h4>
                      {/* Access the HRMS panel using your username and passcode. */}
                    </h4>
                  </div>
                  {isLoggedInSuccess && (
                    <AlertMessage
                      type="success"
                      message="Logged in success, and redirecting..."
                    />
                  )}

                  {errorMessage && (
                    <AlertMessage type="danger" message={errorMessage} />
                  )}
                  <div className="form-login">
                    <label className="form-label">Email Address</label>
                    <div className="form-addons">
                      <input
                        type="text"
                        {...register("email", {
                          required: "Please enter user name",
                        })}
                        placeholder="admin@example.com"
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                    </div>
                    <div className="invalid-feedback">
                      {errors.email?.message}
                    </div>
                  </div>
                  <div className="form-login">
                    <label>Password</label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        {...register("password", {
                          required: "Please enter password",
                        })}
                        placeholder="*****"
                        className={`form-control ${
                          errors.password ? "is-invalid" : ""
                        }`}
                      />
                      <span
                        onClick={() => setShowPassword((prev) => !prev)}
                        className={`fas toggle-password ${
                          showPassword ? "fa-eye" : "fa-eye-slash"
                        }`}
                      />
                    </div>
                    <div className="invalid-feedback">
                      {errors.password?.message}
                    </div>
                  </div>

                  <div className="form-login authentication-check">
                    <div className="row">
                      <div className="col-6">
                        <div className="custom-control custom-checkbox">
                          <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                            <input
                              type="checkbox"
                              {...register("rememberMe")}
                            />
                            <span className="checkmarks" />
                            Keep me login
                          </label>
                        </div>
                      </div>
                      <div className="col-6 text-end">
                        <Link className="forgot-link" to={route.forgotPassword}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="form-login">
                    <button
                      type="submit"
                      className="btn btn-login"
                      disabled={isLoading}
                    >
                      {isLoading && (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Loading...
                        </>
                      )}
                      {!isLoading && <>Sign In</>}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

LoginComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
};

export default LoginComponent;
